import { RefObject, useEffect, useRef } from "react";

export const useIsMountedRef = (): RefObject<boolean> => {
  const mountedReference = useRef(true);
  useEffect(() => {
    mountedReference.current = true;
    return () => {
      mountedReference.current = false;
    };
  }, [mountedReference]);
  return mountedReference;
};
